import { PaginaCrud } from '../components/PaginaCrud'
import type { Producto } from '../types'

export default function Productos() {
  return (
    <PaginaCrud<Producto>
      titulo="Productos"
      recurso="productos"
      llave="id"
      columnas={[
        { campo: 'sku', titulo: 'SKU' },
        { campo: 'nombre', titulo: 'Nombre' },
        { campo: 'descripcion', titulo: 'Descripcion', render: (p) => p.descripcion || '-' },
        { campo: 'unidadMedida', titulo: 'Unidad', render: (p) => p.unidadMedida || '-' },
        { campo: 'pesoKg', titulo: 'Peso (kg)', render: (p) => (p.pesoKg != null ? p.pesoKg : '-') },
        { campo: 'puntoReorden', titulo: 'Pto. reorden', render: (p) => (p.puntoReorden != null ? p.puntoReorden : '-') },
        { campo: 'activo', titulo: 'Activo', render: (p) => (p.activo ? 'Si' : 'No') },
      ]}
      campos={[
        { nombre: 'sku', etiqueta: 'SKU', tipo: 'texto', requerido: true },
        { nombre: 'nombre', etiqueta: 'Nombre', tipo: 'texto', requerido: true },
        { nombre: 'descripcion', etiqueta: 'Descripcion', tipo: 'textarea' },
        { nombre: 'categoriaProductoId', etiqueta: 'Categoria ID', tipo: 'numero' },
        { nombre: 'unidadMedida', etiqueta: 'Unidad de medida', tipo: 'texto' },
        { nombre: 'pesoKg', etiqueta: 'Peso (kg)', tipo: 'decimal' },
        { nombre: 'puntoReorden', etiqueta: 'Punto de reorden', tipo: 'decimal' },
        { nombre: 'activo', etiqueta: 'Activo', tipo: 'checkbox' },
      ]}
      valorInicial={{ tenantId: 1, activo: true }}
    />
  )
}
